import { render, staticRenderFns } from "./EVModelComparison.vue?vue&type=template&id=1a2e8ba1&scoped=true&"
import script from "./EVModelComparison.vue?vue&type=script&lang=js&"
export * from "./EVModelComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e8ba1",
  null
  
)

export default component.exports